(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treads-adventure-browse"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-adventure-browse]').forEach(root=>{const form=root.querySelector('form');form.addEventListener('submit',()=>{const words=root.querySelector('[data-adventure-keywords]').value.trim().split(/\s+/).filter(Boolean).slice(0,12);root.querySelector('[data-adventure-query]').value='tag:adventure-gear'+words.map(word=>' AND "'+word.replace(/[\\"]/g,'\\$&')+'"').join('');});});

  } catch(e) { console.error(e); }
})();
})();
